import * as React from 'react';
import * as main from "../../main.module.scss";
import * as adv from "./style.module.scss";
import { ExpertLicenses } from "../../../../ExpertLicenses";
import { Licenses } from "../../../../Licenses";
import { Modal } from "../../../../Modal";
export const Advance = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <section className={adv.adv}>
        <div className="container">
          <div className={`${adv.container} ${adv.gray}`}>
            <img src="https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg" alt="" className={adv.logo}/>
            <h2>Мы — центр образовательных технологий Advance</h2>
            <ul>
              <li>
                <h3>15 лет</h3>
                <p>учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность</p>
              </li>
              <li>
                <h3>1,6 млн</h3>
                <p>человек<br/> приняли участие<br/> в наших курсах и семинарах</p>
              </li>
              <li>
                <h3>85 000</h3>
                <p>человек<br/> прошли наши полные курсы</p>
              </li>
            </ul>
          </div>
          <div className={`${adv.container} ${adv.violet} ${adv.experts}`}>
            <h2 className={main.title}>Нас ценят эксперты образования</h2>
            <ExpertLicenses subTitleColor={'#FE4D07'} navColor={'#FE4D07'}/>
          </div>
          <div className={`${adv.container} ${adv.orange} ${adv.develop}`}>
            <h2 className={main.title}>Мы развиваем образование</h2>
            <Licenses navColor={'#FE4D07'}/>
          </div>
          <button className={`${main.btn} ${adv.btn}`} onClick={()=>{setShowModal(true)}}>
            Зарегистрироваться бесплатно
          </button>
        </div>

        <Modal
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        >
          { widget }
        </Modal>
      </section>
    </>
  );
}
